import React, { useState } from 'react';
import useShowClass from '../Utils/Hooks/useAnimateClass';

const TabsPreventDefaultAndAnimation = (WrapperComponent) => {
  const Hoc = (props) => {
    const [BasicTab, setBasicTab] = useState('1');
    const [show, setShow] = useShowClass('show');
    const tabActiveHandler = (e, active) => {
      e.preventDefault();
      setShow('');
      setBasicTab(active);
    };
    return <WrapperComponent show={show} tabActive={BasicTab} tabActiveHandler={tabActiveHandler} {...props} />;
  };
  return Hoc;
};

export default TabsPreventDefaultAndAnimation;
